// extracted by mini-css-extract-plugin
export var awardCard = "AwardCard-module--awardCard--8ee14";
export var awardContainer = "AwardCard-module--awardContainer--7ebd0";
export var awardIcon = "AwardCard-module--awardIcon--9dfc0";
export var creativeTitle = "AwardCard-module--creativeTitle--9f36f";
export var project = "AwardCard-module--project--e336d";
export var textContainer = "AwardCard-module--textContainer--6741d";